module.exports = __webpack_public_path__ + "media/src/images/menu/illust-b96407a708c5463ec0147a4022594d1d.png";